<div class="loader-container">
  <div class="beautiful-loader">
    <svg class="logo-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <!-- Static outer base -->
      <circle cx="50" cy="50" r="40" fill="#3f0c9e" />

      <!-- Rotating white + main color split stroke -->
      <g class="rotating-arc">
        <!-- Main color arc (1st and 3rd quarter) -->
        <circle
          cx="50"
          cy="50"
          r="40"
          fill="none"
          stroke="#3f0c9e"
          stroke-width="8"
          stroke-dasharray="62.8 62.8 62.8 62.8"
          transform="rotate(-90 50 50)"
        />
        <!-- White arc (2nd and 4th quarter) -->
        <circle
          cx="50"
          cy="50"
          r="40"
          fill="none"
          stroke="#ffffff"
          stroke-width="8"
          stroke-dasharray="62.8 62.8 62.8 62.8"
          stroke-dashoffset="62.8"
          transform="rotate(-90 50 50)"
        />
      </g>

      <!-- Magnifying glass frame -->
      <circle cx="50" cy="50" r="25" fill="none" stroke="#FFFFFF" stroke-width="5" opacity="0.9" />

      <!-- Lens -->
      <circle cx="50" cy="50" r="20" fill="#FFFFFF" opacity="0.8" />

      <!-- Inner highlight -->
      <circle cx="50" cy="50" r="5" fill="#3f0c9e" />
      <circle cx="52" cy="48" r="1.5" fill="#FFFFFF" />
    </svg>
  </div>
</div>
